import type { ProductCardProps } from '@skin-seoul/shared-components';
import { HorizontalProductCard } from '@skin-seoul/shared-components';
import React from 'react';
import DirectAddToCart from './DirectAddToCart';
import MobileRecentlyViewedProductCardSkeleton from './MobileRecentlyViewedProductCard.skeleton';
import { SafeLink } from '@/components/ui/SafeLink';
type MobileRecentlyViewedProductCardProps = ProductCardProps & {
  isSelected: boolean;
  isDisabled?: boolean;
  onTrackAddToCart?: () => void;
};
const MobileRecentlyViewedProductCard = ({
  isSelected,
  isDisabled = false,
  onTrackAddToCart,
  onClick,
  ...cardProps
}: MobileRecentlyViewedProductCardProps) => {
  return <HorizontalProductCard {...cardProps} onClick={onClick} linkComponent={SafeLink} border="1px solid" height="fit-content" borderColor={isSelected ? 'neutral.300' : 'transparent'} boxShadow="0 0 8px 0 rgba(140, 140, 140, 0.20)" gap={2} cursor={isDisabled ? 'not-allowed' : 'pointer'} data-sentry-element="HorizontalProductCard" data-sentry-component="MobileRecentlyViewedProductCard" data-sentry-source-file="MobileRecentlyViewedProductCard.tsx">
      <HorizontalProductCard.Image backgroundColor="generic.0" height="80px" w="80px" minWidth="80px" p={0} data-sentry-element="HorizontalProductCard.Image" data-sentry-source-file="MobileRecentlyViewedProductCard.tsx" />
      <HorizontalProductCard.Content padding="0 36px 0 0" alignItems="center" justifyContent="center" bottomSlot={<DirectAddToCart sku={cardProps.sku} onTrackAddToCart={onTrackAddToCart} position="absolute" right={2} bottom={2} />} data-sentry-element="HorizontalProductCard.Content" data-sentry-source-file="MobileRecentlyViewedProductCard.tsx">
        <HorizontalProductCard.InfoName nameProps={{
        wordBreak: 'break-all'
      }} data-sentry-element="HorizontalProductCard.InfoName" data-sentry-source-file="MobileRecentlyViewedProductCard.tsx" />
        <HorizontalProductCard.InfoRating data-sentry-element="HorizontalProductCard.InfoRating" data-sentry-source-file="MobileRecentlyViewedProductCard.tsx" />
      </HorizontalProductCard.Content>
    </HorizontalProductCard>;
};
MobileRecentlyViewedProductCard.Skeleton = MobileRecentlyViewedProductCardSkeleton;
export default MobileRecentlyViewedProductCard;